import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Inject, Injectable, NgZone } from '@angular/core';
import { ConfigService } from './config.service';
import { catchError, mergeMap, tap } from 'rxjs/operators';

const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root'
})

export class AutoLogoutService {

  constructor(
    @Inject(ConfigService) private config,
    private auth: AuthService,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.check();
    this.initListener();
    this.initInterval();
  }

  get lastAction() {

    return +localStorage.getItem(STORE_KEY);
  }
  set lastAction(value) {
    localStorage.setItem(STORE_KEY, value.toString());
    this.auth.setLastActive();
    this.auth.setExpiresAt();

  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, this.config.CHECK_INTERVALL);
    });
  }

  reset() {
    this.lastAction = Date.now();
    console.log('reset');
  }

  check() {
    const now = Date.now();
    const timeleft = this.lastAction + this.config.MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff: any = timeleft - now;
    const isTimeout = diff < 0;

    // console.log(`lasAction: ${this.lastAction}`);

    // console.log(`timeLeft ${moment(timeleft).format('DD-MM-YYYY hh:mm:ss')}  now: ${moment(now).format('DD-MM-YYYY hh:mm:ss')}`);
    // console.log(`login Time ${moment(this.auth._loginTime).format('DD-MM-YYYY hh:mm:ss')}`);

    this.ngZone.run(() => {
      // console.log(`BEFORE isTimeout: ${isTimeout} this.auth.loggedIn: ${this.auth.loggedIn}`);

      if (isTimeout && this.auth.loggedIn) {

        const myPromise = val =>
          new Promise(resolve => resolve(val));

        this.auth.getTokenSilently$()
          .pipe(
            mergeMap(val => myPromise(val)),
            catchError(err => myPromise(err))
          )
          .subscribe( val => {
            // console.log(`getToken val : ${val}`);
            console.log(`AFTER----> isTimeout: ${isTimeout} this.auth.loggedIn: ${this.auth.loggedIn}`);
            if (isTimeout && this.auth.loggedIn) {
              console.error('Do LogOUt!!');
              this.auth.logout();
            }
          });
      }
    });
  }
}
